import React, { useEffect } from "react";
import stripe from "../../assets/images/stripe.png";
import { paymnetService } from "services/payment.service";
import { Link } from "react-router-dom";
import useCurrentUser from "hooks/useCurrentUser";
import Footer from "components/Footer/Footer";
import Header from "components/Header/Header";

const StripeAlertpage = () => {
  const { user, socket, setUser } = useCurrentUser();
  const { isStripeConnected } = user || {};

  useEffect(() => {
    if (!socket) return;
    socket.on('stripeConnect', (data) => {
      setUser({
        ...user,
        isStripeConnected: true
      })
    });
    return () => {
      socket.off('stripeConnect', (data) => {
      });
    };
  }, [socket]);

  const getPayment = async (payload) => {
    const response = await paymnetService.ConnectToStripe(payload)
    window.open(response?.data?.data?.stripeConnectUrl, "_blank")
  }

  return (
    <>
      <Header />
      {!isStripeConnected ? (
        <div style={{ marginTop: 200 }}>
          <div className="container">
            <div className="outer-white mission-div">
              <div className="mt-2 ">
                <div className="stripe-card mx-auto text-center">
                  <div className=" mx-auto">
                    <img src={stripe} alt="" />
                  </div>
                  <h2 className="mt-3">Connect to payment gateway</h2>
                  <p>You have successfully verified the account</p>
                  <button onClick={getPayment} className="btn blue-btn text-white">
                    Connect
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div style={{ marginTop: 200 }}>
          <div className="container-box">
            <div className="outer-white mission-div">
              <div className="mt-2 ">
                <div className="stripe-card mx-auto text-center">
                  <div className=" mx-auto">
                    <img src={stripe} alt="" />
                  </div>
                  <h2 className="mt-3">Connected</h2>
                  <p>You have successfully connected Stripe</p>
                  <Link to="/dashboard" className="btn blue-btn text-white">
                    Go To Home
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default StripeAlertpage;
